import { render, staticRenderFns } from "./ChangeRoleModal.vue?vue&type=template&id=05fd2830"
import script from "./ChangeRoleModal.vue?vue&type=script&lang=js"
export * from "./ChangeRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports